import { rateCardListQuerySchema } from '@chukua/common';
import { useListQuery } from '../../../shared/hooks/use-list-query';
import { usePagedList } from '../../../shared/hooks/use-paged-list';
import { listRateCards } from '../rate-cards.api';

/** The page of rate cards the URL's list query asks for. */
export function useRateCardList() {
  const list = useListQuery(rateCardListQuerySchema);
  return { list, ...usePagedList(list.query, listRateCards) };
}
